import * as z from 'zod';
export var createOrUpdateShopFormSchema = function () {
    return z.object({
        name: z.string().min(2, { message: 'shop.validation.name.min' }).max(200, { message: 'shop.validation.name.max' }),
        domain: z.string().min(1, { message: 'shop.validation.domain.min' }).max(100, { message: 'shop.validation.domain.max' }),
    });
};
